<section class="content">
  <div class="container-fluid">

    <form (ngSubmit)="onSubmit(form)" *ngIf=formVisible [formGroup]="form" novalidate>
      <div class="row text-right mb-3">
        <div class="col-md-12">
          <br>
          <button (click)="showHideForm()" class="btn btn-primary" i18n="pulsante indietro" type="button"><i
            class="fas fa-caret-square-left"></i> Indietro
          </button>
        </div>
      </div>
      <div class="card card-info">
        <div class="card-header">
          <h3 class="card-title" i18n="titolo nuovo">{{ form.get('id')?.value ? 'Aggiornamento dati' : 'Nuovo' }}</h3>
        </div>
        <input formControlName="id" type="hidden">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="name" i18n="nome form creazione offerte">Nome</label>
                <input [ngClass]="getInvalidClass('name')" class="form-control" formControlName="name" i18n-placeholder="placeholder nome form creazione offerte"
                       id="name" placeholder="Nome"
                       type="text">
              </div>
              <app-input-errors [element]="form.get('name')"></app-input-errors>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="with_calendar" i18n="nome form creazione offerte">Calendarizzabile</label>
                <ng-select bindLabel="with_calendar" formControlName="with_calendar" id="with_calendar">
                  <ng-option [value]="0">No</ng-option>
                  <ng-option [value]="1">Si</ng-option>
                </ng-select>
              </div>
              <app-input-errors [element]="form.get('with_calendar')"></app-input-errors>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="send_mail">Invio email</label>
                <ng-select (change)="changeSendMail($event)" formControlName="send_mail" id="send_mail">
                  <ng-option [value]="0">No</ng-option>
                  <ng-option [value]="1">Si</ng-option>
                </ng-select>
              </div>
              <app-input-errors [element]="form.get('send_mail')"></app-input-errors>
            </div>
            <div *ngIf="form.get('send_mail')?.value === 1" class="col">
              <div class="form-group">
                <label for="message">Testo Email</label>
                <textarea class="form-control" formControlName="mail_text" id="message" placeholder=""
                          rows="3"></textarea>
                <app-input-errors [element]="form.get('mail_text')"></app-input-errors>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="send_whatsapp">Invio whatsapp</label>
                <ng-select (change)="changeSendWhatsapp($event)" formControlName="send_whatsapp" id="send_whatsapp">
                  <ng-option [value]="0">No</ng-option>
                  <ng-option [value]="1">Si</ng-option>
                </ng-select>
              </div>
              <app-input-errors [element]="form.get('send_whatsapp')"></app-input-errors>
            </div>
            <div *ngIf="form.get('send_whatsapp')?.value === 1" class="col">
              <div class="form-group">
                <label>Testo Whatsapp</label>
                <textarea class="form-control" formControlName="whatsapp_text" id="whatsapp_text" placeholder=""
                          rows="3"></textarea>
                <app-input-errors [element]="form.get('whatsapp_text')"></app-input-errors>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="email_list">Lista email da notificare quando una pratica passa in questo stato (divise da
                  ';' senza spazi)</label>
                <input [ngClass]="getInvalidClass('email_list')" class="form-control" formControlName="email_list" id="email_list"
                       placeholder="Lista Email" type="text">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary" type="submit">Salva</button>
      </div>
    </form>


    <div *ngIf=!formVisible class="row mt-2">
      <div class="col">
        <div class="card">
          <div class="card-header d-flex">
            <h3 class="card-title" i18n="titolo tabella utenti">Elenco stati workflow ({{ paginatedResponse.total }}
              )</h3>
            <app-collapse-button [label]="'Filtri'" [ref]="'collapseFilters'" class="ms-auto"></app-collapse-button>
            <button (click)="new()" class="btn btn-success ms-2" i18n="pulsante nuovo" type="button"><i
              class="fas fa-plus-square"></i> Nuovo
            </button>
          </div>

          <div class="collapse" id="collapseFilters">
            <form (ngSubmit)="onFind(formSearch)" [formGroup]="formSearch" novalidate>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name" i18n="nome form filtri offerte">Nome</label>
                      <input class="form-control" formControlName="name" i18n-placeholder="placeholder nome filtri offerte"
                             placeholder="Nome" type="text">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-right">
                    <button (click)="clearFilters()" class="btn btn-primary" i18n="pulsante pulisci filtri"
                            type="button">Pulisci filtri
                    </button>
                    <button class="btn btn-primary ms-2" i18n="pulsante cerca" type="submit">Cerca</button>
                  </div>

                </div>
              </div>
            </form>
          </div>


          <!-- /.card-header -->
          <div class="card-body table-responsive p-0">
            <table class="table table-hover text-nowrap">
              <thead>
              <tr>
                <th i18n="nome tabella offerte">
                  <app-sort-button (orderChange)="updateList()" [(order)]="order" [column]="'name'"
                                   [label]="'Nome'"></app-sort-button>
                </th>
                <th>
                  <app-sort-button (orderChange)="updateList()" [(order)]="order" [column]="'with_calendar'"
                                   [label]="'Calendarizzabile'"></app-sort-button>
                </th>
                <th>
                  <app-sort-button (orderChange)="updateList()" [(order)]="order" [column]="'send_mail'"
                                   [label]="'Invio email a Cliente'"></app-sort-button>
                </th>
                <th>
                  <app-sort-button (orderChange)="updateList()" [(order)]="order" [column]="'send_whatsapp'"
                                   [label]="'Invio whatsapp a Cliente'"></app-sort-button>
                </th>

                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let object of paginatedResponse.data">
                <td>{{ object.name | titlecase }}</td>
                <td>{{ object.with_calendar ? 'Si' : 'No' }}</td>
                <td>{{ object.send_mail ? 'Si' : 'No' }}</td>
                <td>{{ object.send_whatsapp ? 'Si' : 'No' }}</td>
                <td *ngIf="object.system_code" class="text-danger text-right">Oggetto di sistema</td>
                <td *ngIf="!object.system_code" class="text-right">
                  <button (click)="edit(object)" class="btn btn-primary" type="button"><i class="fas fa-edit"></i>
                  </button>
                  <button (click)="openTrashModal(content,object)" class="btn btn-danger ms-2" type="button"><i
                    class="fas fa-trash-alt"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">

            <app-pagination (elementsChange)="onElementsChange($event)" (pageChangeEvent)="updateList($event)"
                            [paginatedResponse]="paginatedResponse"></app-pagination>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" i18n="pulsante elimina" id="modal-basic-title">Elimina</h4>
    <button (click)="modal.dismiss('cancel')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    Confermi l'eliminazione dello stato?
  </div>
  <div class="modal-footer">
    <button (click)="modal.close('confirm')" class="btn btn-outline-dark" i18n="pulsante conferma" type="button">
      Conferma
    </button>
    <button (click)="modal.dismiss('cancel')" class="btn btn-outline-dark" i18n="pulsante annulla" type="button">
      Annulla
    </button>
  </div>
</ng-template>
